import React from "react";
import PropTypes from "prop-types";
import BondBillingInformationBase from "../../shared/components/BondBillingInformationBase";
import { getBillingSurfaceConfig } from "../../shared/billingSurfaceConfig";
import { GoogleAutoComplete, LabeledCreatableSelect } from "../../shared/widgets";
import { PLACES_TYPES_GEOCODE } from "../../../../globals/components/forms/GoogleAutoCompleteField";

const BillingGoogleAutoComplete = (props) => (
  <GoogleAutoComplete placesTypes={PLACES_TYPES_GEOCODE} {...props} />
);

const BillingInformation = ({ globalData, data, updateData, isGuest }) => (
  <BondBillingInformationBase
    cfg={getBillingSurfaceConfig("creationGuardianship")}
    GoogleAutoComplete={BillingGoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    data={data}
    updateData={updateData}
    globalData={globalData}
    isGuest={isGuest}
  />
);

BillingInformation.propTypes = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  isGuest: PropTypes.bool,
};

export default BillingInformation;
